/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./controllable-popover.vue?vue&type=template&id=675ba522&scoped=true&"
import script from "./controllable-popover.vue?vue&type=script&lang=js&"
export * from "./controllable-popover.vue?vue&type=script&lang=js&"
import style0 from "./controllable-popover.vue?vue&type=style&index=0&id=675ba522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ba522",
  null
  
)

export default component.exports